import { useStore } from '@/stores/main';

export default () => {
  const store = useStore();
  if (!store.loggedIn) return { path: '/login' };
  if (store.onboarding.status === 'complete') return { path: '/home' };
  return true;
};
